var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "overlay-container",
    class: _vm.overlayClass
  }, [_c('div', {
    staticClass: "main-container"
  }, [_vm.isShownTitle ? _c('div', {
    staticClass: "title-container"
  }, [_c('capusta-title', {
    attrs: {
      "route-back": "login"
    }
  })], 1) : _vm._e(), _c('two-factor-auth-content', {
    attrs: {
      "content": _vm.currentState
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }